import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BreathingCircle } from '@/components/focus/BreathingCircle';

export function FocusBreathAnimation() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="py-24 sm:py-32 relative overflow-hidden">
      {/* Ambient glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-96 h-96 bg-primary/10 rounded-full blur-[100px]" />
      </div>
      
      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            Find Your Flow
          </h2>
          <p className="text-lg text-muted-foreground mb-12">
            Take a breath. Then take action.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex justify-center mb-12"
        >
          <div className="scale-150">
            <BreathingCircle variant="focus" />
          </div>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-sm text-muted-foreground italic"
        >
          "What's the ONE Thing you can do today that would make everything else easier or unnecessary?"
        </motion.p>
      </div>
    </section>
  );
}
